import Service from '../../services'
import * as _ from 'lodash'

const state = {
    room: {
        id: null,
        building: {
            id: null,
            name: '',
            data_object: {
                width: 0,
                height: 0
            },
            image: null
        },
        level: {
            id: null,
            name: '',
            data_object: {
                width: 0,
                height: 0
            },
            image: null
        },
        name: '',
        image: null
    },
    buildingList: [],
    levelList: [],
    roomList: [],
}

const getters = {}

const actions = {

    onGetAllBuilding({ commit }) {
        return Service.base.getAllBuilding().then(data => {
            commit('setBuildingList', data);
            return data
        });
    },
    onGetAllLevelByBuilding({ commit }, id) {
        return Service.base.getAllLevelByBuilding(id).then(data => {
            commit('setLevelList', data);
            return data
        });
    },
    onGetAllRoomByLevel({ commit }, id) {
        return Service.room.getAllRoomByLevel(id).then(data => {
            commit('setRoomList', data);
            return data
        });
    },
    async setSelectedRoom({ commit, state }, data) {
        // Get room type data and gallery.
        const roomType = await Service.base.getById(data.room_type_id)
        const roomTypeGallery = await Service.base.getAllRoomTypegalleryByRoomType(roomType.id)

        const selectedRoom = {
            ...data,
            building: state.room.building,
            level: state.room.level,
            promotion: data.promotion
                ? {
                    ...data.promotion,
                    data_object: JSON.parse(data.promotion.data)
                }
                : null,
            room_type: {
                ...roomType,
                gallery: roomTypeGallery
            }
        }

        commit('setSelectedRoom', selectedRoom)
    },

    async refreshRoomData({ state, dispatch }) {
        const room = await Service.room.getById(state.room.id)
        return dispatch('setSelectedRoom', room)
    },

    onClearBooking({ commit }, mode) {
        return commit('clearBooking', mode);
    },

    async onGetSpecialOffer({ commit, dispatch }, roomTypeId) {
        const specialOffer = await Service.room.getAvailableRoomOffer(roomTypeId)

        if (!specialOffer) {
            alert('No offer found.')
        }

        // Get all building.
        const buildings = await dispatch('onGetAllBuilding')
        const building = buildings.find(building => building.id === specialOffer.building_id)

        // Get level by building.
        const levels = await dispatch('onGetAllLevelByBuilding', specialOffer.building_id)
        const level = levels.find(level => level.id === specialOffer.level_id)
        level.value = level.id
        level.text = level.name
        level.disabled = parseInt(level.active) === 2

        // Get room type data and gallery.
        const roomType = await Service.base.getById(specialOffer.room_type.id)
        const roomTypeGallery = await Service.base.getAllRoomTypegalleryByRoomType(roomType.id)

        // Get rooms by level.
        await dispatch('onGetAllRoomByLevel', specialOffer.level_id)

        commit('setSelectedRoom', {
            ...specialOffer,
            building,
            level,
            promotion: specialOffer.promotion ? {
                ...specialOffer.promotion,
                data_object: JSON.parse(specialOffer.promotion.data)
            } : null,
            room_type: {
                ...roomType,
                gallery: roomTypeGallery
            },
        })
    }
};


const mutations = {

    setSelectedRoom(state, data) {
        state.room = data;
    },
    setBuildingList(state, data) {
        state.buildingList = data;
    },
    setLevelList(state, data) {
        state.levelList = data;
    },
    setRoomList(state, data) {
        state.roomList = data;
    },
    clearBooking(state, mode) {
        switch (mode) {
            case 'building':
                state.room.id = null;
                state.room.level = {
                    id: null,
                    name: '',
                    data_object: {
                        width: 0,
                        height: 0
                    },
                    image: null
                };
                break;

            case 'level':
                state.room.id = null;
                break;

            default:
                state.room = {
                    id: null,
                    building: {
                        id: null,
                        name: '',
                        data_object: {
                            width: 0,
                            height: 0
                        },
                        image: null
                    },
                    level: {
                        id: null,
                        name: '',
                        data_object: {
                            width: 0,
                            height: 0
                        },
                        image: null
                    },
                    name: '',
                    image: null
                }

        }

    }

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}